import Button from 'components/UI/Buttons/Button'
import Typography from 'components/UI/Typography'
import { useAppSelector } from 'hooks'
import { useCreditDecision } from 'hooks/useCreditDecision'
import { DecisionViews, InsuranceCompanies } from 'pages/Decision/constants'
import { Fragment, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getStatusSelector } from 'redux/store/slices/statusSlice'
import tw from 'twin.macro'

import LoanIncludes from './Insurance/LoanIncludes'
import LoanInsurance from './Insurance/LoanInsurance'
import LoanActivitySelection from './LoanActivitySelection'
import LoanCancelButton from './LoanCancelBlock'
import LoanConditionsWrapper from './LoanConditionsWrapper'

type LoanConfirmationProps = {
  isLoading: boolean
  onSetDecision: () => void
}

const LoanConfirmation = ({ isLoading, onSetDecision }: LoanConfirmationProps) => {
  // Tools
  const { t } = useTranslation()

  // State
  const [isActivitySelected, setIsActivitySelected] = useState(false)
  const [insuranceCompany, setInsuranceCompany] = useState(InsuranceCompanies.freedom)

  // Selectors
  const { skip_corp_card_creation = true } = useAppSelector(getStatusSelector)

  // Custom hooks
  const { selectedSubProgram, onMainViewChange } = useCreditDecision()

  // Mutations

  // Handlers
  const handleIsActivitySelectedChange = (value: boolean) => {
    window.scrollTo(0, 0)
    setIsActivitySelected(value)
  }

  const handleContinueConfirmation = () => {
    if (skip_corp_card_creation === true) {
      onSetDecision()
      return
    }

    onMainViewChange(DecisionViews['CHOOSE-DELIVERY-ADDRESS'])
  }

  return (
    <Fragment>
      <div tw='space-y-3'>
        <LoanConditionsWrapper />
        {selectedSubProgram?.with_pledges ? (
          <Fragment>
            <LoanIncludes />
            <LoanInsurance insurance={insuranceCompany} onInsuranceChange={setInsuranceCompany} />
          </Fragment>
        ) : null}
        <LoanActivitySelection
          isActivitySelected={isActivitySelected}
          onIsActivitySelectedChange={handleIsActivitySelectedChange}
        />
      </div>
      <div tw='px-4 mt-8 flex flex-col justify-center space-y-3 md:px-0 md:flex-row-reverse md:space-y-0'>
        <Button
          variant='primary'
          twStyle={tw`flex-1 ml-0 md:ml-5`}
          disabled={!isActivitySelected || insuranceCompany !== InsuranceCompanies.freedom}
          loading={isLoading}
          onClick={handleContinueConfirmation}
        >
          <Typography variant='body' weight='bold' twStyle={tw`text-white`}>
            {t('flow-condition-agreed')}
          </Typography>
          <Typography variant='caption' twStyle={tw`text-white`}>
            {t('flow-go-to-sign')}
          </Typography>
        </Button>
        <LoanCancelButton buttonTextStyles={tw`text-red-light lg:whitespace-nowrap font-medium`} />
      </div>
    </Fragment>
  )
}

export default LoanConfirmation
